// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"2021":"7b371528","2589":"32fc1245","3040":"3b778964","7032":"854d08f8"}[chunkId] + ".css";
};